module.exports = __webpack_public_path__ + "img/serviceicon2.ab8ffeb9.gif";